import { HttpStatus } from '../types';
import { AppError, ErrorTypes } from './app.error';

type InternalServerErrorArgs = {
    detail?: string;
    instance: string;
    [key: string]: unknown;
};

export class InternalServerError extends AppError {
    constructor({ detail, instance, ...rest }: InternalServerErrorArgs) {
        super({
            ...rest,
            status: HttpStatus.INTERNAL_SERVER_ERROR,
            type: ErrorTypes.INTERNAL_SERVER_ERROR,
            title: 'Internal Server Error',
            detail,
            instance,
        });
    }
}
